export default __webpack_public_path__ + "static/media/Alejandro Loguercio_small-5.6775ae85.jpg";